import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledMuiListItem = (
  theme: Theme,
): BackstageOverrides['MuiListItem'] => ({
  root: {
    minHeight: theme.spacing(5),
    paddingBottom: theme.spacing(0.25),
    paddingTop: theme.spacing(0.25),

    '@media (min-width: 600px)': {
      minHeight: theme.spacing(5),
    },
  },
});
